import type { AnyLayer } from 'mapbox-gl';

export const STYLES = {
  dark: 'mapbox://styles/mapbox/dark-v10',
  streets: 'mapbox://styles/mapbox/streets-v11',
} as const;

export type STYLES_KEYS_TYPE = keyof typeof STYLES;
export type STYLES_VALUES_TYPE = (typeof STYLES)[STYLES_KEYS_TYPE];

export const buildingsLayer: AnyLayer = {
  id: 'add-3d-buildings',
  type: 'fill-extrusion',
  source: 'composite',
  'source-layer': 'building',
  minzoom: 15,
  filter: ['==', 'extrude', 'true'],
  paint: {
    'fill-extrusion-color': '#aaa',
    // Use an 'interpolate' expression to
    // add a smooth transition effect to
    // the buildings as the user zooms in.
    'fill-extrusion-height': [
      'interpolate',
      ['linear'],
      ['zoom'],
      15,
      0,
      15.05,
      ['get', 'height'],
    ],
    'fill-extrusion-base': [
      'interpolate',
      ['linear'],
      ['zoom'],
      15,
      0,
      15.05,
      ['get', 'min_height'],
    ],
    'fill-extrusion-opacity': 0.6,
  },
};
